import React from "react";
import { Head } from "../../components";
import { Link } from "react-router-dom";
import "./forbidden.css"

function Forbidden() {
  return (
    <>
      <div className="forbidden-g">
        <Link to='./' >
            <Head title="HTTP 401 - Forbidden" />
        </Link>
      </div>      
    </>
  );
}

export default Forbidden;

